import React from "react";
import { NavLink } from "react-router-dom";
import Profile from "./Profile";

const AboutUs = () => {
  return (
    <section
      className="minister-section-container"
      style={{
        // width: "100vw",
        // minHeight: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "0 20px",
        margin: "0",
        color: "#fff",
      }}
    >
      <h2
        className="minister-section-title"
        style={{
          textAlign: "center",
          padding: "20px 20px",
          fontWeight: "bold",
          fontSize: "2.5rem",
          fontFamily: "'EB Garamond', serif",
          letterSpacing: "1.5px",
          color: "#FFFFFF",
          fontStyle: "italic",
          margin: 0,
        }}
      >
        Head of Department
      </h2>
      <Profile />

      {/* About JTDC Section */}
      <div
        className="small-section cws_prlx_section"
        id="jtdc-main-grid"
        style={{
          display: "flex",
          gap: "40px",
          alignItems: "flex-start",
          justifyContent: "space-between",
          // maxWidth: "1200px",
          margin: "40px auto",
          padding: "0 20px",
          flexWrap: "wrap",
        }}
      >
        <div
          className="about-jtdc"
          style={{
            flex: "1 1 320px",
            color: "#ffffff",
            minWidth: 0,
          }}
        >
          <h4
            className="aboutSection-title text-center text-md-start"
            style={{
              color: "#ffb347",
              marginBottom: "15px",
              fontWeight: "bold",
              fontSize: "1.8rem",
              fontFamily: "'EB Garamond', serif",
              letterSpacing: "1px",
              fontStyle: "italic",
            }}
          >
            About JTDC
          </h4>
          <p
            className="aboutSection-description"
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              color: "#f2f2f2",
            }}
          >
            The Jharkhand Tourism Development Corporation (JTDC) Ltd. plays a
            pivotal role in promoting the rich cultural heritage and natural beauty
            of Jharkhand. Established with the aim of making Jharkhand a premier
            tourist destination, JTDC is dedicated to enhancing the state's
            tourism infrastructure, ensuring a seamless and memorable experience
            for travelers.
          </p>
          <div style={{ display: "flex", justifyContent: "start" }}>
            <NavLink
              to="/About"
              style={{
                background: "linear-gradient(135deg, #ff7a00, #ffb347)",
                color: "white",
                fontSize: "1.1rem",
                fontWeight: 500,
                padding: "12px 26px",
                borderRadius: "50px",
                boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#000000";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.2)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "white";
                e.currentTarget.style.boxShadow = "0 6px 15px rgba(0, 0, 0, 0.1)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Know More
            </NavLink>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            minWidth: 0,
            marginTop: "20px",
          }}
        >
          <img
            src="images/About_JTDC.jpg"
            alt="Jharkhand Tourism"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
